class DateUtils {
    static convertStringToDate(dateString) {
        if (!dateString || dateString === "") return ""
        const [ year, month, day ] = dateString.split('-')    
        return new Date(`${month}/${day}/${year.slice(2,4)}`)
    }

    static convertHolidayDate(date) {
        if (date === "") return ""
        const year = date.slice(0,2)
        const month = date.slice(2,4)
        const day = date.slice(4)
        return `${month}/${day}/${year}`        
    }    
}

export default DateUtils